import { render, staticRenderFns } from "./drawerImport.vue?vue&type=template&id=2d088e54&"
import script from "./drawerImport.vue?vue&type=script&lang=js&"
export * from "./drawerImport.vue?vue&type=script&lang=js&"
import style0 from "./drawerImport.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports